import React, { Component } from 'react'

import urlFor, { QueryParams } from 'shared/tools/url-helper'
import { getShowcaseResourcesType } from 'client/bookmate/helpers/showcase-helpers'

import {
  ExpandableBubblesList,
  NavItem,
} from 'client/shared/blocks/expandable-bubbles-list'

import { Navigation, ContentType } from 'client/shared/types/showcase'

const MAX_VISIBLE_NAVIGATION_ITEMS = 4

type Props = {
  navigation: Navigation[]
  language: string
  slug: string
  contentType: ContentType
  size?: string
  query?: QueryParams
}

export class TopicNavigationList extends Component<Props> {
  prepareItem = (topic: Navigation): NavItem => {
    const { slug, language, contentType, query } = this.props

    const isSubtopic = topic.type === 'topic'
    const topicHierarchy = urlFor.topicHierarchy({
      topic: `${isSubtopic ? slug : topic.params.slug}-${language}`,
      subtopic: isSubtopic ? topic.params.slug : undefined,
      resourceType: getShowcaseResourcesType(contentType),
      query,
    })
    const path = isSubtopic ? topicHierarchy.subtopic : topicHierarchy.topic

    return {
      id: topic.params.uuid || topic.params.slug,
      title: topic.title,
      path,
    }
  }

  render(): JSX.Element | null {
    const { navigation, size } = this.props

    if (navigation.length === 0) return null

    const shouldHide =
      size === 'mobile' && navigation.length > MAX_VISIBLE_NAVIGATION_ITEMS

    return (
      <ExpandableBubblesList
        shouldHide={shouldHide}
        items={navigation.map(this.prepareItem)}
      />
    )
  }
}
